module.exports = "<div class=\"row\">\n  <div class=\"col-12 dy-table\" >\n    <ng2-smart-table [settings]=\"settings\" [source]=\"sourceData\"></ng2-smart-table>\n  </div>\n</div>\n\n<iw-manage-function #modalTable [document]=\"documentSelectFunction\" \n  (saveFunction)=\"saveFuntion($event)\" >\n</iw-manage-function>"


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/basic-process-configuration/manage-document/manage-document.component.html
// module id = ./src/app/administration/basic-process-configuration/manage-document/manage-document.component.html
// module chunks = main